import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ErrorBoundaryContext } from 'apps/web_forms/components/ErrorBoundaryContext';

const ErrorFallbackContainer = styled.div`
  pre {
    margin-top: 0.5em;
  }
`;

const ErrorFallback = ({ error }) => {
  // TODO: use the error passed in? Or do we not want the user to see it?
  const failingQuestionIdentifier = React.useContext(ErrorBoundaryContext);
  return (
    <ErrorFallbackContainer role="alert">
      <p>{`Something went wrong with this field (${failingQuestionIdentifier})`}</p>
      <pre style={{ color: 'red' }}>
        Please contact support to get assistance
      </pre>
    </ErrorFallbackContainer>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Error)])
    .isRequired,
};

export default ErrorFallback;
